<template>
    <v-form v-model="valid" ref="datosDelInmueble" lazy-validation>
        <v-row>
            <v-col cols="12" class="grey--text font-weight-bold">
                Datos de la publicación
            </v-col>

            <v-col cols="12">
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-text-field v-model="datos.fechaDeCreacion"
                                      disabled
                                      label="Fecha de creación">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4">
                        <v-text-field v-model="datos.fechaDeCreacion"
                                      disabled
                                      label="Fecha de actualización">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" sm="4">
                <v-select v-model="datos.proposito"
                          label="Propósito"
                          :items="constants.purpose"
                          :rules="[rules.required]"
                          clearable>
                </v-select>
            </v-col>

            <v-col cols="12" sm="4">
                <v-select v-model="datos.estado"
                          label="Estado"
                          disabled
                          readonly
                          :items="constants.state">
                </v-select>
            </v-col>

            <v-col cols="12" sm="4">
                <v-select v-model="datos.habilitarEnLaWeb"
                          label="Habilitar"
                          :items="constants.enableInTheWeb"
                          clearable>
                </v-select>
            </v-col>

            <v-col class="px-0" cols="12" >
                <v-divider></v-divider>
            </v-col>

            <v-col cols="12">
                <v-row>
                    <v-col cols="12" sm="4" v-if="datos.proposito !== 'Venta y Arriendo'">
                        <v-autocomplete v-model="datos.asesor"
                                        label="Asesor"
                                        :items="advisers"
                                        item-text="nombres"
                                        :loading="advisers.length === 0"
                                        :rules="[rules.required]"
                                        clearable>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="4" v-if="datos.proposito === 'Venta y Arriendo'">
                        <v-select v-model="datos.asesorVenta"
                                  label="Asesor de Venta"
                                  :items="advisers"
                                  item-text="nombres"
                                  :loading="advisers.length === 0"
                                  :rules="[rules.required]"
                                  clearable>
                        </v-select>
                    </v-col>

                    <v-col cols="12" sm="4" v-if="datos.proposito === 'Venta y Arriendo'">
                        <v-select v-model="datos.asesorArriendo"
                                  label="Asesor de Arriendo"
                                  :items="advisers"
                                  item-text="nombres"
                                  :loading="advisers.length === 0"
                                  :rules="[rules.required]"
                                  clearable>
                        </v-select>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12" sm="6">
                <v-select v-model="datos.tipoDePropiedad"
                          label="Tipo de propiedad"
                          :items="constants.propertiesTypes"
                          item-text="label"
                          :rules="[rules.required]"
                          clearable>
                </v-select>
            </v-col>

            <v-col cols="12" sm="6">
                <v-autocomplete v-model="datos.propietario"
                                :rules="[rules.required]"
                                :items="owners"
                                item-text="nombres"
                                label="Propietario"
                                clearable>
                    <template #prepend-item>
                        <v-list-item @click="createNewOwner">
                            <v-list-item-avatar>
                                <v-icon>add</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Crear propietario
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                    </template>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-money="money"
                              v-model="datos.valorDeVenta"
                              label="Valor de venta"
                              :disabled="!datos.proposito || datos.proposito === 'Arriendo'"
                              :rules="datos.proposito && datos.proposito !== 'Arriendo' ? [rules.required] : []"
                              clearable>
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-money="money"
                              v-model="datos.valorDeArriendo"
                              label="Valor de arriendo"
                              :disabled="!datos.proposito || datos.proposito === 'Venta'"
                              :rules="datos.proposito && datos.proposito !== 'Venta' ? [rules.required] : []"
                              clearable>
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-money="money"
                              v-model="datos.valorPredial"
                              label="Valor predial">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-autocomplete v-model="datos.frecuenciaPredial"
                                :items="constants.propertyFrequency"
                                clearable
                                label="Frecuencia de predial">
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-money="money"
                              v-model="datos.valorDeAdministracion"
                              label="Valor de administración">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-money="money"
                              v-model="datos.avaluoCatastral"
                              label="Avaluo catastral">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-money="area"
                              v-model="datos.areaConstruida"
                              label="Área construida">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" v-if="showAreaLote">
                <v-text-field v-money="area"
                              v-model="datos.areaLote"
                              label="Área lote">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6" v-if="!showAreaLote">
                <v-text-field v-money="area"
                              v-model="datos.areaTerraza"
                              label="Área terraza"></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" v-if="datos.tipoDePropiedad !== 'Lote'">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-text-field label="Llaves" v-on="on"></v-text-field>
                    </template>

                    <span>Esta información se muestra solo para los asesores que inicien sesión</span>
                </v-tooltip>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-model="datos.fechaDeCreacion"
                              disabled
                              label="Fecha de creación">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
                <v-autocomplete v-model="datos.destacado"
                                :items="constants.outstandingProperty"
                                label="Destacado"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6">
                <v-text-field v-model="datos.ordenDestacado"
                              :disabled="datos.destacado !== 'Si'"
                              label="Orden destacado">
                </v-text-field>
            </v-col>

            <v-col cols="12">
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="abadPrimary" @click="submit" dark>Continuar</v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapState } from 'vuex'
import constants from '@/pages/RealEstate/libs/constants'
import moment from 'moment'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapState({
      advisers: state => state.realEstate.advisers,
      datos: state => state.realEstate.datos,
      owners: state => state.realEstate.owners
    }),
    showAreaLote () {
      return this.conditionsShowAreaLote.includes(this.datos.tipoDePropiedad)
    }
  },
  created () {
    this.$store.commit('SET_FECHA_DE_CREACION')
  },
  data () {
    return {
      area: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' m²',
        precision: 0,
        masked: false
      },
      conditionsShowAreaLote: [
        'Lote',
        'Casa',
        'Casa Oficina',
        'Finca',
        'Casa Campestre',
        'Bodega',
        'Lote Industrial'
      ],
      constants,
      updateDate: moment().format('DD/MM/YYYY'),
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      },
      rules,
      valid: true
    }
  },
  methods: {
    submit () {
      const stateForm = this.$refs.datosDelInmueble.validate()
      this.$emit('updateStateForm', stateForm)
      if (!stateForm) return

      console.log('estoy aqui')
    },
    createNewOwner () {
      this.$emit('createNewOwner')
    }
  },
  watch: {
    'datos.proposito' (value) {
      switch (value) {
        case 'Venta': {
          this.datos.valorDeArriendo = undefined
          this.datos.estado = 'En venta'
          break
        }
        case 'Arriendo': {
          this.datos.estado = 'En arriendo'
          this.datos.valorDeVenta = undefined
          break
        }
        case 'Venta y Arriendo': {
          this.datos.estado = 'En venta y arriendo'
          this.datos.valorDeVenta = undefined
          break
        }
        case undefined: {
          this.datos.estado = ''
          this.datos.valorDeVenta = undefined
          this.datos.valorDeArriendo = undefined
        }
      }
    }
  }
}
</script>
